<template>
  <div :class="`contact-method contact-method--${size}`">
    <div class="contact-method__title">
      <tooltip :content="$t('shared.component.v-copy.copy')" placement="right" trigger="hover">
        <span class="contact-method__number" @click="copy(item.format_number)">
          {{ item.format_number }}
          <icon type="md-copy" size="20" />
        </span>
      </tooltip>
      <small class="contact-method__label">
        {{ $t(`pbx.contact-method.label.${item.label}`) }}
      </small>
    </div>

    <div class="contact-method__description">
      <label-icon class="contact-method__label-icon" :type="item.label" />
      <type-badge :value="item.format_type" />
    </div>

    <div v-if="$slots['controls']" class="contact-method__controls">
      <slot name="controls"></slot>
    </div>
  </div>
</template>

<script>
  import LabelIcon from '@pbx/components/contact-methods/_fragments/label/icon/index';
  import TypeBadge from '@pbx/components/contact-methods/_fragments/type/badge/index';

  export default {
    components: { LabelIcon, TypeBadge },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },

      size: {
        type: String,
        default: 'default'
      }
    },
    methods: {
      copy: function (value) {
        this.$copyText(value).then(() => {
          this.$noty.success(this.$t('shared.component.noty.text_copied'));
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .contact-method {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &--small {
      .contact-method__number {
        font-size: 12px;
        line-height: 14px;
      }
    }

    &__title {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &__number,
    &__label {
      flex: 0;
    }

    &__number {
      color: $text-color;
      font-size: 14px;
      line-height: 17px;
    }

    &__label {
      color: $blue-grey-light;
      font-size: 10px;
      line-height: 12px;
      width: 100%;
    }

    &__description {
      display: flex;
      align-items: center;
    }

    &__label-icon {
      margin-right: 10px;
    }

    &__controls {
      width: 24px;
      margin-left: 5px;
    }
  }
</style>
